/* Created by Interactive 63 - https://interactive63.com */
/**
 * Minification for compiler output. These functions rely on the compiler controlling the CSS
 * grammar it writes, so they must never be applied to CSS from anywhere else.
 */

import { CREDIT_TEXT } from '../branding';

export const CREDIT_CSS = `/* ${CREDIT_TEXT} */`;
export const CREDIT_MARKUP = `<!-- ${CREDIT_TEXT} -->`;

/** Removes comments except the credit, collapses whitespace and tightens punctuation. */
export function minifyCss(css: string): string {
  const hasCredit = css.includes(CREDIT_CSS);
  const body = css
    .replace(/\/\*[\s\S]*?\*\//g, '')
    .replace(/\s+/g, ' ')
    .replace(/\s*([{}:;,])\s*/g, '$1')
    .replace(/;}/g, '}')
    .trim();
  return hasCredit ? `${CREDIT_CSS}${body}` : body;
}

/** Elements inside which whitespace is part of the content. */
const SIGNIFICANT_WHITESPACE = new Set(['text', 'tspan', 'textPath', 'style', 'title', 'desc']);

/** Removes whitespace-only text nodes between elements, except inside text elements. */
function stripWhitespace(node: Node): void {
  for (const child of Array.from(node.childNodes)) {
    if (child.nodeType === 3 && (child.textContent ?? '').trim() === '') {
      const parent = child.parentNode;
      if (!(parent instanceof Element && SIGNIFICANT_WHITESPACE.has(parent.localName))) {
        child.remove();
      }
    } else if (child.nodeType === 1) {
      stripWhitespace(child);
    }
  }
}

/** Minifies SVG markup by removing whitespace between elements. */
export function minifyMarkup(markup: string): string {
  const doc = new DOMParser().parseFromString(markup, 'image/svg+xml');
  stripWhitespace(doc.documentElement);
  return new XMLSerializer().serializeToString(doc.documentElement);
}
